module.exports = __webpack_public_path__ + "img/icon_permissions.7238f096.png";